import { render, staticRenderFns } from "./jy-palletPutOn.vue?vue&type=template&id=0a88b333&scoped=true&"
import script from "./jy-palletPutOn.vue?vue&type=script&lang=js&"
export * from "./jy-palletPutOn.vue?vue&type=script&lang=js&"
import style0 from "./jy-palletPutOn.vue?vue&type=style&index=0&lang=css&"
import style1 from "./jy-palletPutOn.vue?vue&type=style&index=1&id=0a88b333&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a88b333",
  null
  
)

export default component.exports